import { render, staticRenderFns } from "./DialogFreeOfCharge.vue?vue&type=template&id=50005f7e&scoped=true&"
import script from "./DialogFreeOfCharge.vue?vue&type=script&lang=ts&"
export * from "./DialogFreeOfCharge.vue?vue&type=script&lang=ts&"
import style0 from "./DialogFreeOfCharge.vue?vue&type=style&index=0&id=50005f7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50005f7e",
  null
  
)

component.options.__file = "DialogFreeOfCharge.vue"
export default component.exports